import _ from 'lodash';
import { isVisibleToolState } from 'app/CornerstoneTools/constants';
import { ToolsStates } from 'app/adapters/ImageRenderer/ConfigurableToolsOptions';
import { ImageAnnotations } from 'app/interfaces/Image';

export default function extractVisibleAnnotations(
  annotations: ImageAnnotations,
  toolsStates: ToolsStates
): ImageAnnotations {
  return _.pickBy(annotations, (annotation, annotationName: keyof ToolsStates) =>
    isVisibleToolState(toolsStates[annotationName]?.state)
  );
}
